// extracted by css-extract-rspack-plugin
export default {"root":"DbS1Rv","data":"wOrNQf","heading":"I_J_Vg","value":"KfE7Tc","label":"F_v8a6"};